<template>
  <div class="contaier" v-loading="loading">
    <div class="title">霍兰德职业兴趣测试</div>
    <div class="font">国际专业职业测评、了解兴趣 找准职业、被广泛运用于专业选择 职业发展等领域</div>
    <div class="list" v-for="(item,i) in list" :key="i" v-if="index==item.sort">
       <div class="head">
          <div class="left">
            <div class="curr">{{item.sort}}</div>
            <div class="num">/{{list.length}}</div>
          </div>
          <div class="right">
            <div class="tip">
                <div class="right-font">{{parseInt(item.sort/list.length*100)}}%</div>
                <div class="right-font2">即将获取专业分析报告</div>
            </div>
            <div class="progress">
                 <el-progress :percentage="parseInt(item.sort/list.length*100)" :show-text="false"></el-progress>
            </div>
          </div>
       </div>
       <div class="subject">
         <div class="img">
            {{item.title}}
         </div>
         <div class="option">
            <div class="option-item" @click="itemClick(item,1)" :class="[item.select=='是'?'mask':'']">
               <div>是</div>
            </div>
            <div class="option-item" @click="itemClick(item,2)" :class="[item.select=='否'?'mask':'']">
               <div>否</div>
            </div>
         </div>
       </div>


    </div>

    <div class="btn">
       <div class="pagedown left" v-if="index>1" @click="index=index-1">
          <img src="../../assets/下载.png" alt="">
          <div class="font">上一题</div>
       </div>
       <div class="pagedown right" @click="xiayiti()" v-if="list.length>index">
         <div class="font">下一题</div>
         <img src="../../assets/right.png" alt="">
       </div>
       <div class="pagedown right" @click="HuoMember_add()" v-if="index==list.length">
         <div class="font">立即提交获取结果</div>
         <img src="../../assets/right.png" alt="">
       </div>
    </div>

    <div class="tips"  style="margin-top: 80px;line-height: 40px;">
        <div>
           <div>[1］测评时间预计8-16分钟，请在心态平和及时间充足的情况下开始答题。</div>
           <div>[2］选项间无对错好坏之分，请选择与你实际做法相符的，而不是你认为怎样做是对的。</div>
           <div>[3］答题完成将获得专业的分析报告，并在系统中永久保存。</div>
        </div>
     </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from "vuex"
  import { Huolan_index,HuoMember_add } from "@/api/gw/ceping"
  export default {
    computed: {
      ...mapGetters(['isLogin', "userinfo"]),
    },
    data(){
      return{
        loading:false,
        list:[],
        index:1,//默认题索引
      }
    },
    mounted(){
      console.log("login8")
      this.$store.dispatch("getUserInfo").then(res=>{
        if(res.role==1){
          this.$confirm('此测评为VIP专属功能，开通VIP才可以使用?', '提示', {
            confirmButtonText: '购买VIP',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              path: "/Home",
              query: {
                type: 3
              }
            })
          })
        }else{
           this.Huolan_index();
        }
      })
    },
    methods:{
      //提交结果
      HuoMember_add(){
        let list = [...this.list];
        //先判断所有题是否都已经答完
        const index = list.findIndex(item => item.select == "");
        if(index>-1){
          this.$message.error(`第${index+1}题必做`);
          return;
        }
        //计算 j和P S和N F和T E和I
        //计算规则：汇总总个数，相等则取后值
        let a = [];
        let b= [];
        list.forEach(r=>{
          if(r.select=="是"){
            a.push("是")
            b.push(r.yes)
          }
          if(r.select=="否"){
            a.push("否")
            // b.push(r.yes)
          }
        })
        this.loading = true
        HuoMember_add({
          result:a.join(","),
          huolanresult:b.join(",")
        }).then(()=>{
          this.$message.success("提交成功");
          this.$router.push({
            path:"/HollanderResult"
          })
        }).finally(()=>{
          this.laoding = false
        })
      },
      Huolan_index(){
        this.loading = true
        Huolan_index({}).then(res=>{
          res.data.forEach((r,j)=>{
            this.$set(r,"sort",j+1);
            this.$set(r,"select","");
          })
          this.list = res.data
        }).finally(()=>{
          this.loading = false
        })
      },
      //下一题
      xiayiti(){
        let find = this.list.find((item,i)=>{
             if(item.sort==this.index){
               return item;
             }
        })
        if(find && !find.select){
          this.$message.error("请回答此题");
          return;
        }
        this.index = this.index+1;
      },
      //回答题
      itemClick(item,type){
         if(type==1){
           this.$set(item,"select","是");
         }
         if(type==2){
           this.$set(item,"select","否");
         }
         if(this.index<this.list.length){
           setTimeout(()=>{
             this.index = item.sort+1;
           },50)
         }
      },
    }
  }
</script>
<style lang="scss" scoped>
  @import './scss/info.scss';
</style>



// WEBPACK FOOTER //
// src/views/appraisal/Hollander.vue